import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Search, MapPin, Phone } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { SUBURBS, BIZ } from "@/content";

export const Areas = () => {
  const [q, setQ] = useState("");
  const list = SUBURBS.filter((s) => s.toLowerCase().includes(q.trim().toLowerCase()));
  return (
    <section id="areas" className="bg-white py-24 lg:py-32" data-testid="areas-section">
      <div className="mx-auto max-w-[1400px] px-5 lg:px-10">
        <div className="grid gap-12 lg:grid-cols-12">
          <Reveal className="lg:col-span-5">
            <Eyebrow>Service areas</Eyebrow>
            <h2 className="font-display text-4xl font-extrabold leading-[1] tracking-tight text-[#0F2B5B] sm:text-6xl">Servicing all of Perth metro.</h2>
            <p className="mt-6 max-w-md text-base text-slate-600 md:text-lg">We're a mobile business, so we come to you — north, south, east or west. Check your suburb below, or just give us a call.</p>
            <a href={BIZ.tel} className="mt-8 inline-flex items-center gap-2 font-display text-2xl font-extrabold text-[#0F2B5B] hover:text-[#E05A00]" data-testid="areas-call-link">
              <Phone className="h-5 w-5 text-[#FF6B00]" /> {BIZ.phone}
            </a>
          </Reveal>
          <Reveal className="lg:col-span-7" delay={0.1}>
            <label className="relative block">
              <span className="sr-only">Search your suburb</span>
              <Search className="absolute left-5 top-1/2 h-5 w-5 -translate-y-1/2 text-slate-500" />
              <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Check your suburb…" data-testid="service-area-search-input"
                className="w-full rounded-full border border-slate-300 bg-[#FAF9F6] py-4 pl-14 pr-5 text-base outline-none transition-[border-color,box-shadow] focus:border-[#FF6B00] focus:ring-4 focus:ring-[#FF6B00]/15" />
            </label>
            <motion.ul layout className="mt-6 flex flex-wrap gap-2.5" data-testid="service-area-list">
              <AnimatePresence>
                {list.map((s) => (
                  <motion.li layout key={s} initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.9 }}
                    className="flex items-center gap-1.5 rounded-full border border-slate-200 bg-[#F0F5FA] px-4 py-2 text-sm font-semibold text-[#0F2B5B]">
                    <MapPin className="h-3.5 w-3.5 text-[#FF6B00]" /> {s}
                  </motion.li>
                ))}
              </AnimatePresence>
            </motion.ul>
            {list.length === 0 && (
              <p className="mt-6 rounded-2xl bg-[#FFF4EC] p-5 text-[#0F2B5B]" data-testid="service-area-empty">
                Not on our list? We cover all of Perth metro — call <a href={BIZ.tel} className="font-bold text-[#E05A00]">{BIZ.phone}</a> and we'll confirm.
              </p>
            )}
          </Reveal>
        </div>
      </div>
    </section>
  );
};
